var map = {
	"./airBaltic-club-logo.svg": 649,
	"./american-express.svg": 1091,
	"./applepay.svg": 1092,
	"./bitpay.png": 1093,
	"./capa.svg": 1094,
	"./google.svg": 1095,
	"./googlepay.svg": 1096,
	"./instagram.svg": 1097,
	"./klix-logo.svg": 1098,
	"./master-card.svg": 1099,
	"./oag/de.svg": 1100,
	"./oag/en.svg": 1101,
	"./oag/et.svg": 1102,
	"./oag/fi.svg": 1103,
	"./oag/lt.svg": 1104,
	"./oag/lv.svg": 1105,
	"./oag/ru.svg": 1106,
	"./pay-pal.svg": 1107,
	"./pins.svg": 1108,
	"./trustly.png": 1109,
	"./uatp.png": 1110,
	"./visa.svg": 1111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1090;